import * as types from 'constants/ActionTypes';
import { createReducer } from 'utils/ReduxUtils';

const initialState = false;

const isLoading = () => true;

const isEnded = () => false;

export default createReducer(initialState, {
  [types.FETCH_DEALER_REQUEST]: isLoading,
  [types.FETCH_DEALERS_REQUEST]: isLoading,
  [types.FETCH_DEALERS_SELECT_REQUEST]: isLoading,
  [types.CREATE_DEALER_REQUEST]: isLoading,
  [types.CHANGE_DEALER_STATUS_REQUEST]: isLoading,
  [types.FETCH_DEALERS_BY_REDUCER_REQUEST]: isLoading,

  [types.FETCH_DEALER_FAILURE]: isEnded,
  [types.FETCH_DEALERS_FAILURE]: isEnded,
  [types.FETCH_DEALERS_SELECT_FAILURE]: isEnded,
  [types.CREATE_DEALER_FAILURE]: isEnded,
  [types.CHANGE_DEALER_STATUS_FAILURE]: isEnded,

  [types.FETCH_DEALER_SUCCESS]: isEnded,
  [types.FETCH_DEALERS_SUCCESS]: isEnded,
  [types.FETCH_DEALERS_SELECT_SUCCESS]: isEnded,
  [types.CREATE_DEALER_SUCCESS]: isEnded,
  [types.CHANGE_DEALER_STATUS_SUCCESS]: isEnded,
});
